import { shopifyComponentCopy } from '@testfeed/product-language'
import type { TestsIndexStatusIssue } from '../types'

/** Inline, retryable note for a row whose latest status refresh failed. */
export function StatusIssueNote({ issue, onRetry }: { issue: TestsIndexStatusIssue; onRetry: () => void }) {
  const copy = shopifyComponentCopy.testsIndex
  return (
    <s-stack direction="inline" gap="small-200" alignItems="center">
      <s-icon type="alert-circle" tone="warning"></s-icon>
      <s-text color="subdued">{issue.kind === 'invalid' ? copy.statusIssueInvalid : copy.statusIssueFailed}</s-text>
      <s-link onClick={onRetry}>{copy.retryAction}</s-link>
    </s-stack>
  )
}
